


























import Vue from 'vue'
import { RoamingMultiCountryPickerElInterface } from '@/config/interfaces'

type CountryItem = {
  text: string;
  value: string;
  isSelected: boolean;
};
export default Vue.extend({
  name: 'RoamingMultiCountryPicker',
  data: () => ({
    country: ''
  }),
  props: {
    templateItemData: {
      type: Object as () => RoamingMultiCountryPickerElInterface,
      required: true
    }
  },
  computed: {
    countries (): Array<Record<string, string>> {
      const countries: Array<Record<string, string>> = []

      this.templateItemData.countries.forEach((country) => {
        countries.push({
          text: country.val,
          value: country.key
        })
      })

      return countries
    },
    defaultCountries (): CountryItem[] {
      const defaultCountries: CountryItem[] = []

      this.templateItemData.checkboxlist.forEach((country) => {
        defaultCountries.push({
          text: country.val,
          value: country.key,
          isSelected: country.value
        })
      })
      return defaultCountries
    },
    background (): string {
      return `background-color: ${this.$props.templateItemData.background || 'transparent'};`
    }
  },
  methods: {
    addNewCountry () {
      if (this.country.trim() !== '') {
        const foundCountry = this.countries.find(country => country.value === this.country)
        if (foundCountry && !this.defaultCountries.some((defaultCountry) => defaultCountry.value === foundCountry.value)) {
          this.defaultCountries.push({
            text: foundCountry.text,
            value: foundCountry.value,
            isSelected: true
          })
        }
        this.country = ''
      }
    },
    sendRequest () {
      const selectedCountries = this.defaultCountries.reduce((params, country) => {
        params.append(country.value, country.isSelected.toString())
        return params
      }, new URLSearchParams())
      this.getView(this.templateItemData.button.view, this.templateItemData.button.uri, selectedCountries)
    }
  }
})
